const server = process.env.REACT_APP_API_URL;
const server2 = process.env.REACT_APP_URL;
const server3 = process.env.REACT_APP_URL2;

export { server, server2, server3 };
